<template>
  <div class="container">
    <div v-if="!isMobile" class="pcWrapper">
      <div class="ach__relationsWrapper">
        <div class="ach_bannerWrapper">
          <img src="https://img.i2soft.net/i2official-web/assets/images/relations/gov_back.png" />
          <div class="bannerTextWrapper"></div>
        </div>
        <div class="announcementWrapper">
          <div class="top_box">
            <div class="pc_change">
              <a @click.prevent="jump('anc')" v-bind:class="{ active: staic == 'anc' }">公司公告</a>
              <a v-bind:class="{ active: staic == 'gov' }">公司治理</a>
              <a @click.prevent="jump('acv')" v-bind:class="{ active: staic == 'acv' }">业绩报告</a>
              <a @click.prevent="jump('ser')" v-bind:class="{ active: staic == 'ser' }">投资者服务</a>
            </div>
          </div>
        </div>
        <div class="mapWrapper">
          <div class="investor-governance-s2" id="gov">
            <div class="top-block">
              <div @click="func('DSH')" v-bind:class="{ active: active == 'DSH' }">董事会</div>
              <div @click="func('GJ')" v-bind:class="{ active: active == 'GJ' }">高级管理层</div>
            </div>
            <div class="bot-block">
              <div v-if="block == 'DSH'" class="bot-block-container">
                <!-- 董事会无数据时显示 -->
                <div v-if="governanceData.DSH.length === 0" class="no-data-custom">
                  <el-empty description="暂无董事会成员信息"></el-empty>
                </div>
                <div v-else class="child">
                  <div class="box" v-for="(item, index) in governanceData.DSH" :key="index">
                    <h4 class="h4">{{ item.mgrName }}</h4>
                    <h3 class="h3">{{ item.jobTitle }}</h3>
                  </div>
                </div>
              </div>
              <div v-if="block == 'GJ'" class="bot-block-container">
                <!-- 高级管理层无数据时显示 -->
                <div v-if="governanceData.GJ.length === 0" class="no-data-custom">
                  <el-empty description="暂无高级管理层成员信息"></el-empty>
                </div>
                <div v-else class="child">
                  <div class="box" v-for="(item, index) in governanceData.GJ" :key="index">
                    <h4 class="h4">{{ item.mgrName }}</h4>
                    <h3 class="h3">{{ item.jobTitle }}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="investor-governance-s3" id="consti">
            <div class="wrapper">
              <div class="inner-tit center gray">
                <WaveTitle style="margin-top: 20px" :title="'公司章程'" :subhead="'Articles of association'"></WaveTitle>
              </div>
              <div class="cont">
                <a :href="(charterData && charterData.ruleUrl) || 'https://www.bse.cn/disclosure/2025/2025-03-14/5f53c5a78aa045649c5dadb607e2c4a8.pdf'" target="_blank">
                  <div class="img-box">
                    <div class="centerZc">
                      <div class="topWhite"></div>
                      <div class="cmpNameZc">{{ charterData && charterData.title ? (charterData.title.split("公司章程")[0] || "上海艾融软件股份有限公司") : "上海艾融软件股份有限公司" }}</div>
                      <div class="nameZc">公司章程</div>
                      <div class="nameZcDetail">{{ charterData && charterData.remark }}</div>
                      <div class="bottomWhite"></div>
                      <div class="clickDetail">点击查看详情</div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { isMobile } from "@/utils/index";
  import $ from "jquery";
  import WaveTitle from "@/components/WaveTitle";
  import { useGetGovernmentListApi, useGetChartListApi } from "@/api/useGovernmentApi";

  export default {
    components: {
      WaveTitle,
    },
    data() {
      return {
        isMobile: false,
        active: "",
        block: "",
        staic: "",
        query_type: "",
        location: "",
        // 公司治理数据
        governanceData: {
          DSH: [],
          JSH: [],
          GJ: [],
        },
        // 公司章程数据
        charterData: null,
      };
    },
    filters: {},
    created() {
      this.getachievent();
      this.query_type = this.$route.query.category;
      this.location = this.$route.query.location;
      this.pg_change(this.query_type);
      this.func(this.location);
      // 获取公司治理数据
      this.fetchAllGovernanceData();
      // 获取公司章程数据
      this.fetchCharterData();
    },
    mounted() {
      this.isMobile = isMobile();
      window.addEventListener("scroll", this.getScroll);
    },
    destroyed() {
      window.removeEventListener("scroll", this.getScroll);
    },
    methods: {
      // 获取公司章程数据
      async fetchCharterData() {
        try {
          const res = await useGetChartListApi({
            pageNum: 1,
            pageSize: 10,
          });

          if (res && res.records && res.records.length > 0) {
            this.charterData = res.records[0]; // 使用第一条记录
          }
        } catch (error) {
          console.error("获取公司章程数据失败:", error);
        }
      },

      // 获取所有治理数据
      async fetchAllGovernanceData() {
        await this.fetchGovernanceData("DSH");
        await this.fetchGovernanceData("JSH");
        await this.fetchGovernanceData("GJ");
      },

      // 根据类型获取治理数据
      fetchGovernanceData(type) {
        const params = {
          pageNum: 1,
          pageSize: 100,
          gvmtType: type,
        };

        // 使用正确的API调用
        return useGetGovernmentListApi(params)
          .then((res) => {
            if (res.records && res.records.length > 0) {
              this.governanceData[type] = res.records;
            }
          })
          .catch((error) => {
            console.error(`获取${type}数据失败:`, error);
          });
      },

      // 跳转
      jump(type) {
        if (type == "anc") {
          this.$router.push({ path: "/Announce", query: { category: type } });
        } else if (type == "acv") {
          this.$router.push({ path: "/Achievement", query: { category: type } });
        } else if (type == "ser") {
          this.$router.push({ path: "/Service", query: { category: type } });
        }
      },
      // 跳转后tab标签的改变
      pg_change(type) {
        console.log("static", type);
        console.log("this.query_type", this.query_type);
        this.staic = type;
      },
      // 获取业绩表
      getachievent() {
        // 股东权益
        this.$axios.get("/parameter/shareholderList").then((res) => {
          this.shareholderList = res.data.data;
          console.log("年报业报", this.shareholderList);
        });
      },
      // 切换tab
      func(c) {
        console.log("c", c);
        if (!c) {
          this.active = "DSH";
          this.block = "DSH";
          window.scrollTo(0, 540);
        } else {
          if (c != "consti") {
            const hash = window.location.hash;
            const index = hash.lastIndexOf("#");
            if (index != -1) {
              const id = hash.substring(index + 1, hash.length + 1);
              setTimeout(function () {
                console.log("值", $(document.getElementById(id)).offset().top);
                $("html, body").animate({ scrollTop: $(document.getElementById(id)).offset().top - 43 }, 500);
              }, 0);
            }
            this.active = c;
            this.block = c;
          } else {
            const hash = window.location.hash;
            const index = hash.lastIndexOf("#");
            if (index != -1) {
              const id = hash.substring(index + 1, hash.length + 1);
              setTimeout(function () {
                $("html, body").animate({ scrollTop: $(document.getElementById(id)).offset().top - 43 }, 500);
              }, 0);
            }
            this.active = "DSH";
            this.block = "DSH";
          }
        }
      },
      getScroll() {
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if (!!document.documentElement.scrollTop && document.documentElement.scrollTop >= 70) {
          this.$store.commit("TO_AfterScroll");
        } else {
          this.$store.commit("TO_AfterScroll_false");
        }
      },
      nowLink() {
        window.open("https://ir.p5w.net/c/830799.shtml");
      },
    },
  };
</script>
<style lang="less" scoped>
  * {
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .ach__relationsWrapper {
    background-color: #ffffff;

    .ach_bannerWrapper {
      width: 100%;
      position: relative;

      img {
        width: 100%;
        height: auto;
      }

      .bannerTextWrapper {
        position: absolute;
        top: 45%;
        left: 45%;
        display: flex;
        flex-direction: column;

        .bannerText1 {
          color: #ffffff;
          font-size: 30px;
          text-align: left;
          font-family: PingFangSC-Medium;
        }

        .bannerText2 {
          color: rgba(255, 255, 255, 100);
          font-size: 40px;
          text-align: left;
          font-family: PingFangSC-Medium;
        }

        .bannerText3 {
          color: rgba(255, 255, 255, 100);
          font-size: 30px;
          text-align: left;
          font-family: PingFangSC-Light;
        }
      }
    }

    .announcementWrapper {
      margin-top: -6px;
      background-color: #f4f0d7;
      padding: 0 20px;
      display: flex;
      flex-direction: row;
      justify-content: center;

      .top_box {
        width: 75%;
      }

      .pc_change {
        margin-right: 25px;
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        align-items: center;
        justify-content: flex-end;
        column-gap: 31px;

        a {
          padding: 20px 0;
          cursor: default;
          text-decoration: none;
          color: #000000;
          font-size: 15px;
          cursor: pointer;
        }

        a:hover {
          color: #f49a42;
        }

        .active {
          color: #f49a42;
        }
      }
    }

    .mapWrapper {
      display: flex;
      flex-direction: column;
      margin: auto;
      padding: 0px;

      .investor-governance-s1 {
        padding: 6.25vw 0;

        .wrapper {
          width: 80%;
          max-width: 1560px;
          margin: 0 auto;
          position: relative;
          z-index: 2;
          text-align: left;

          .center {
            text-align: center;

            h3 {
              color: #333333;
              font-size: 26px;
            }
          }

          .tip {
            font-size: 14px;
            color: #333333;
            margin-top: 20px;
          }

          .cont {
            margin-top: 2vw;
            font-size: 0;

            .head-box {
              background-image: linear-gradient(90deg, #001066, #2f50a2);

              span:nth-of-type(1) {
                padding-left: 3.125vw;
                font-size: 18px;
              }

              span:nth-of-type(2) {
                font-size: 18px;
                width: 40%;
              }

              span:nth-of-type(3) {
                font-size: 18px;
                width: 15%;
              }

              span {
                font-size: 18px;
                display: inline-block;
                vertical-align: top;
                width: 15%;
                line-height: 3.75;
                color: #fff;
              }
            }

            .item:nth-of-type(even) {
              background-color: #f7f7f7;
            }

            .item {
              border-bottom: 1px solid #e6e6e6;

              span:nth-of-type(1) {
                padding-left: 3.125vw;
              }

              span:nth-of-type(2) {
                width: 40%;
              }

              span:nth-of-type(3) {
                width: 15%;
              }

              span {
                display: inline-block;
                vertical-align: top;
                width: 15%;
                font-size: 12px;
                line-height: 3;
                color: #333333;
              }
            }
          }
        }
      }

      .investor-governance-s2 {
        padding: 6.25vw 0;
        //background-color: #f7f7f7;
        background: white;

        .top-block {
          font-size: 0;
          text-align: center;
          border-bottom: 1px solid #d9d9d9;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          column-gap: 100px;

          div {
            vertical-align: top;
            font-size: 18px;
            line-height: 40px;
            color: #333333;
            text-align: center;
            width: 200px;
            transition: all 0.3s ease;
            cursor: pointer;
            padding-bottom: 10px;
          }
          .active {
            padding-bottom: 10px;
            font-size: 24px;
            border-bottom: 2px solid #f49a42;
            color: #f49a42;
          }

          .wrapper {
            width: 80%;

            span {
              font-size: 18px;
              padding-bottom: 10px;
            }

            .active {
              font-size: 24px;
              padding-bottom: 10px;
              border-bottom: 2px solid #f49a42;
              color: #f49a42;
            }
          }
        }

        .bot-block {
          margin-top: 3vw;
          display: flex;
          flex-direction: column;
          align-items: center;

          .bot-block-container {
            width: 80%;
            .child {
              width: 100%;
              display: grid;
              grid-template-columns: repeat(3, 1fr);
              column-gap: 2vw;
              row-gap: 2vw;

              .box {
                width: 100%;
                padding: 3vw 20px;
                cursor: pointer;
              }

              h4 {
                font-size: 14px;
              }

              h3 {
                font-size: 18px;
              }

              .box:hover h3 {
                font-size: 24px;
                font-weight: 900;
                color: #b08d57;
              }

              .box:hover h4 {
                font-size: 28px;
                font-weight: 900;
                color: #b08d57;
              }

              .box:hover {
                background-image: url("https://img.i2soft.net/i2official-web/v2/assets/images/relations/loveWen.png");
                background-size: 200%;
                background-clip: border-box;
                // background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                transform: translateY(-20px);
                box-shadow: 0 26px 40px -24px rgb(0 36 100 / 50%);
              }
            }
          }

          .box {
            display: inline-block;
            vertical-align: top;
            width: calc((100% - 6.2vw) / 3);
            position: relative;
            padding: 3.5vw 2.5vw;
            background-color: #eaeff3;
            // margin-top: 2vw;
            // margin-right: 2vw;
            transition: all 0.3s ease;

            h4 {
              font-size: 16px;
              color: #808080;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              position: relative;
              z-index: 2;
              transition: color 0.3s ease;
            }

            h3 {
              font-size: 24px;
              color: #333333;
              margin-top: 15px;
              position: relative;
              z-index: 2;
              transition: color 0.3s ease;
            }
          }
        }
      }

      .investor-governance-s3 {
        padding: 6.25vw 0;

        .wrapper {
          width: 100%;

          .center {
            text-align: center;
          }

          h3 {
            font-size: 26px;
          }

          .cont {
            margin-top: 2vw;
            font-size: 0;
            width: 100%;

            a {
              width: 100%;
              display: flex;
              width: 100%;
              text-decoration: none;
              color: #333;

              .img-box {
                width: 100%;
                //max-width: 960px;
                height: 592px;
                overflow: hidden;
                background-image: url("https://img.i2soft.net/i2official-web/v2/assets/images/relations/cmpZcBg.png");
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                display: flex;
                justify-content: center;
                align-items: center;

                .centerZc {
                  .topWhite {
                    margin: 0 auto;
                    width: 404px;
                    height: 72px;
                    border-top: 1px solid #ffffff;
                    border-left: 1px solid #ffffff;
                    border-right: 1px solid #ffffff;
                  }

                  .cmpNameZc {
                    margin: 0 auto;
                    font-size: 48px;
                    font-weight: 500;
                    color: #ffffff;
                    margin-top: 20px;
                  }

                  .nameZc {
                    margin: 0 auto;
                    font-size: 56px;
                    font-weight: 900;
                    color: #ffffff;
                    margin-top: 20px;
                  }

                  .nameZcDetail {
                    margin: 0 auto;
                    font-size: 18px;
                    font-weight: 300;
                    color: #ffffff;
                    margin-top: 20px;
                  }

                  .bottomWhite {
                    margin: 0 auto;
                    width: 404px;
                    height: 72px;
                    border-bottom: 1px solid #ffffff;
                    border-left: 1px solid #ffffff;
                    border-right: 1px solid #ffffff;
                    margin-top: 20px;
                  }

                  .clickDetail {
                    margin: 0 auto;
                    font-size: 24px;
                    font-weight: 500;
                    color: #ffffff;
                    margin-top: 80px;
                  }
                }
              }

              //img {
              //    display: block;
              //    width: 100%;
              //    transition: transform .6s ease;
              //    vertical-align: middle;
              //    border: none;
              //}

              //.txt-box {
              //    position: relative;
              //    width: 38%;
              //    padding: 6.25vw 3.125vw;
              //    background-image: linear-gradient(90deg, #001066, #2f50a2);
              //    text-align: center;
              //    color: #ffffff;
              //
              //    h4 {
              //        font-size: 18px;
              //    }
              //
              //    h3 {
              //        font-size: 32px;
              //        margin-top: 1.5vw;
              //    }
              //
              //    .tip {
              //        position: absolute;
              //        bottom: 3.125vw;
              //        left: 2.125vw;
              //        right: 2.125vw;
              //        font-size: 12px;
              //    }
              //}
            }
          }
        }
      }
    }
  }
</style>
